import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import {
  ServiceCategoryTypes,
} from '@/modules/employer/types/ServiceCategories.types';

export const getCategories = () => api.get(API_URL.ENUMS_SERVICE_CATEGORIES);

export const QUERY_KEY = 'getServiceCategories';
const useServiceCategoriesQuery = () => {
  const { data, isLoading } = useQuery([QUERY_KEY, getCategories], getCategories);

  const list = useMemo(
    () =>
      data?.data.map(
        (item): ServiceCategoryTypes => ({
          id: toString(item.id),
          key: item.name || '',
          value: item.description || '',
        })
      ),
    [data]
  );

  return { isLoading, list: list || [] };
};

export default useServiceCategoriesQuery;
